import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { api } from "@/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(null); // null checking, true/false resolved

  const refresh = async () => {
    try {
      const res = await api.get("/auth/me");
      setUser(res.data);
      setIsAuthenticated(true);
      return res.data;
    } catch (e) {
      setUser(null);
      setIsAuthenticated(false);
      return null;
    }
  };

  useEffect(() => {
    let mounted = true;
    const run = async () => {
      try {
        const res = await api.get("/auth/me");
        if (!mounted) return;
        setUser(res.data);
        setIsAuthenticated(true);
      } catch (e) {
        if (!mounted) return;
        setUser(null);
        setIsAuthenticated(false);
      }
    };
    run();
    return () => {
      mounted = false;
    };
  }, []);

  const value = useMemo(
    () => ({
      user,
      isAuthenticated,
      setUser,
      setIsAuthenticated,
      refresh,
      logout: async () => {
        await api.post("/auth/logout");
        setUser(null);
        setIsAuthenticated(false);
      },
    }),
    [user, isAuthenticated],
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within AuthProvider");
  return ctx;
}
